import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { DateBarComponent } from './date-bar.component'
import { AnalyticsModule } from '../../../shared/analytics/analytics.module'
import { CustomLinkModule } from '../../custom-link/custom-link.directive.module'

@NgModule({
  declarations: [DateBarComponent],
  exports: [DateBarComponent],
  imports: [CommonModule, AnalyticsModule, CustomLinkModule]
})
export class DateBarModule {}
